let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("4Jbf1")).then(() => parcelRequire('1qW0V'));